module.exports = __webpack_public_path__ + "img/no-image.fc2bed63.png";